module.exports = __webpack_public_path__ + "static/media/img_preview@2x.4ebb44b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_preview@2x.png
// module id = 941
// module chunks = 0